import { FormFieldTypes } from "../../../../../components/finalForms/libs/data/formFieldType";
import { validationTypes } from "../../../../../components/finalForms/libs/data/ValidationTypes";
import { GridColumnType } from "../../../../../data/gridColumnType";

const initState = {
  projectDomainName: '',
  isActive: '',
}

const FormData = {
  name: "Project Domain",
  initialState: initState,

  section: [
    {
      sectionId: 'Project Domain',
      title: "Project Domain Section",
      row: {},
      style: {
        sectionStyle: "col-lg-12 col-md-12 mb-2",
      },
      wrapperTemplate: <div className="form-card row"></div>, 
      fields: [
        {
          id: "ProjectDomainName",
          label: "Project Domain Name",
          Field_Name: "Project Domain Name",
          fieldType: FormFieldTypes.INPUT,
          dataField: "projectDomainName",
          fieldSetting: {
            placeholder: "Please Enter Project Domain Name",
            allowSpace: true,
            isDisable: false,
            maxLength: 50,
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 col-md-12 mb-1 validation-left-0",
          },
        },
        {
          id: "isActive",
          label: "Is Active",
          Field_Name: "isactive",
          fieldType: FormFieldTypes.CHECKBOX,
          dataField: "isActive",
          fieldSetting: {
            allowSpace: true,
          },
          style: {
            containerCss: "col-lg-6 col-md-6 mt-2 double-label-sec checkbox-style",
          },
        },
      ]
    }
  ]
}

export const projectDomainGridConfig = {
  columns: [
    {
      name: "Project Domain Name",
      fieldName: "projectDomainName",
      colStyle: {
        width: "60%",
        textAlign: "center",
      },
    },
    {
      name: "Status",
      fieldName: "isActive",
      colType: GridColumnType.CHECKBOX,
      allowShort: false,
      colStyle: {
        width: "25%",
        textAlign: "center",
      },
    },

    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: true,
        allowDelete: true,
      },
      colStyle: {
        width: "15%",
        textAlign: "center",
      },
    },
  ],
};

export default FormData;
